import { initDataTable } from './dependencies/initDataTable.js';
import { initChart } from './dependencies/initChart.js';
import {  startScenarioTour, 
          parseAppTable, 
          parseNutrientTable,
          updateChart,
          updateRows,
          runTheNumbers } from './dependencies/functions-scenarios.js';

// import logos. for the PDF generation
import './dependencies/logo.js';
import './dependencies/andelogo.js';
var logo = window.logoData;
var andelogo = window.andeLogoData;

// import clicks and such from events.js
import './dependencies/events-scenarios.js';

export function initScenario() {

  initDataTable()

  chartData = runTheNumbers()

  updateRows()

  initChart()

  ///// TOUR //////////////////

  if (sessionStorage.newUser == "true" ) {
    startScenarioTour()
  }

  $(document).on('click','#start-tour', function(){
    startScenarioTour()
  })

  // save a local storage variable to indicate weeks display preferebce
  $('input[name="weeks-display"]').on('change', function() {
    var val = $(this).val();
    localStorage.weeksDisplay = val;

    if ( val == 'dates' ) {
      weeksArray = ["Jan 1", "Jan 8", "Jan 15", "Jan 22", "Jan 29", "Feb 5", "Feb 12", "Feb 19", "Feb 26", "Mar 5", "Mar 12", "Mar 19", "Mar 26", "Apr 2", "Apr 9", "Apr 16", "Apr 23", "Apr 30", "May 7", "May 14", "May 21", "May 28", "Jun 4", "Jun 11", "Jun 18", "Jun 25", "Jul 2", "Jul 9", "Jul 16", "Jul 23", "Jul 30", "Aug 6", "Aug 13", "Aug 20", "Aug 27", "Sep 3", "Sep 10", "Sep 17", "Sep 24", "Oct 1", "Oct 8", "Oct 15", "Oct 22", "Oct 29", "Nov 5", "Nov 12", "Nov 19", "Nov 26", "Dec 3", "Dec 10", "Dec 17", "Dec 24"];
    } else {
      weeksArray = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7", "Week 8", "Week 9", "Week 10", "Week 11", "Week 12", "Week 13", "Week 14", "Week 15", "Week 16", "Week 17", "Week 18", "Week 19", "Week 20", "Week 21", "Week 22", "Week 23", "Week 24", "Week 25", "Week 26", "Week 27", "Week 28", "Week 29", "Week 30", "Week 31", "Week 32", "Week 33", "Week 34", "Week 35", "Week 36", "Week 37", "Week 38", "Week 39", "Week 40", "Week 41", "Week 42", "Week 43", "Week 44", "Week 45", "Week 46", "Week 47", "Week 48", "Week 49", "Week 50", "Week 51", "Week 52"];
    } 

    config.data.labels = weeksArray;
    updateChart( chartData );

    // update the select2s
    $('.product-week-select').each(function(){
      var val = $(this).val();
      $(this).empty();
      for (var i = 0; i < weeksArray.length; i++) {
        var option = new Option(weeksArray[i], i+1, false, false);
        $(this).append(option);
      }
      $(this).val( val ).trigger('change');
    });


  }
  );

  // on load, check for weeks display preference
  if ( localStorage.weeksDisplay ) {
    var val = localStorage.weeksDisplay;
    $('input[name="weeks-display"][value="'+val+'"]').prop('checked', true);

    if ( val == 'dates' ) {
      weeksArray = ["Jan 1", "Jan 8", "Jan 15", "Jan 22", "Jan 29", "Feb 5", "Feb 12", "Feb 19", "Feb 26", "Mar 5", "Mar 12", "Mar 19", "Mar 26", "Apr 2", "Apr 9", "Apr 16", "Apr 23", "Apr 30", "May 7", "May 14", "May 21", "May 28", "Jun 4", "Jun 11", "Jun 18", "Jun 25", "Jul 2", "Jul 9", "Jul 16", "Jul 23", "Jul 30", "Aug 6", "Aug 13", "Aug 20", "Aug 27", "Sep 3", "Sep 10", "Sep 17", "Sep 24", "Oct 1", "Oct 8", "Oct 15", "Oct 22", "Oct 29", "Nov 5", "Nov 12", "Nov 19", "Nov 26", "Dec 3", "Dec 10", "Dec 17", "Dec 24"];
    } else {
      weeksArray = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7", "Week 8", "Week 9", "Week 10", "Week 11", "Week 12", "Week 13", "Week 14", "Week 15", "Week 16", "Week 17", "Week 18", "Week 19", "Week 20", "Week 21", "Week 22", "Week 23", "Week 24", "Week 25", "Week 26", "Week 27", "Week 28", "Week 29", "Week 30", "Week 31", "Week 32", "Week 33", "Week 34", "Week 35", "Week 36", "Week 37", "Week 38", "Week 39", "Week 40", "Week 41", "Week 42", "Week 43", "Week 44", "Week 45", "Week 46", "Week 47", "Week 48", "Week 49", "Week 50", "Week 51", "Week 52"];
    }

    config.data.labels = weeksArray;
    updateChart( chartData );

    // update the select2s
    $('.product-week-select').each(function(){
      var val = $(this).val();
      $(this).empty();
      for (var i = 0; i < weeksArray.length; i++) {
        var option = new Option(weeksArray[i], i+1, false, false);
        $(this).append(option);
      }
      $(this).val( val ).trigger('change');
    });

  }

  //// PDF Make //////////////////////////

  $(document).on('click','.btn-make-pdf', function(){

    var mode = $(this).data('mode')

    if ( $("#save-scenario").hasClass('dirty') ) {
        alert("Please save your changes before generating a PDF.")
        return false;
    }

    loadjs(['/js/scenario/pdfmake.min.js'], function() {
      loadjs('/js/scenario/vfs_fonts.js', function(){
        
        var title = $('#scenario-title').text();
        var notes = $('.scenario-notes-input').val();
        var turfType = $('.turf-type-display').text();
        var targetN = $('#target-nitrogen').val();
        var coverage = $('#coverage').val() + $('#coverage-units').text();
        var zone = $('.scenario-zone-select option:selected').text();
        var carryOverAmt = $('.carryover-amt').text();
        var showPricing = $('.show-pricing-hidden').val();
        var country = $('.country-hidden').val();
        var units = $('.units-hidden').val();
        var summaryItems = $('article.summary-item');


        switch(units) {
          case 'imperial':
            var targetUnits = ' lbs/1000 ft';
            var coverageUnits = "acres";
            break;
          case 'metric':
            var targetUnits = ' kg/100 m';
            var coverageUnits = "hectares";
            break;
          default:
        }

        var year = new Date().getFullYear();

        if ( showPricing == '1' ) {
          var appColumns = [25,33,50,55,15,15,27,37,20,20,20] // ~314?
          // var preHeader = [
          //   { columns: [
          //   	{text: 'Nutrients Delivered (lbs/1000 ft', fontSize: 6, width: 'auto'},
          //   	{text: '2', width: 'auto', fontSize: 4},
          //     {text: ')', width: 'auto', fontSize: 6,}
          //   ], margin: [ 398, 0, 0, 0 ] },
          //   { canvas: [ {	type: 'rect', x: 390, y: 5, w: 100, h: 0.5, r: 0, color: '#dee2e6', } ]}
          // ]
        } else {
          var appColumns = [30,33,88,55,30,40,25,25,25]
          // var preHeader = [
          //   { columns: [
          //   	{text: 'Nutrients Delivered (lbs/1000 ft', fontSize: 6, width: 'auto'},
          //   	{text: '2', width: 'auto', fontSize: 4},
          //     {text: ')', width: 'auto', fontSize: 6,}
          //   ], margin: [ 393, 0, 0, 0 ] },
          //   { canvas: [ {	type: 'rect', x: 380, y: 5, w: 110, h: 0.5, r: 0, color: '#dee2e6', } ]}
          // ]
        }

        if (carryOverAmt != "0") {
          var carryoverBanner = {
            headerRows: 1,
            widths: [ 'auto' ],
            body: [
              [{ columns: [
                {text: 'This scenario will produce ' + carryOverAmt + ' ' + targetUnits, width: 'auto', fontSize: 7},
                {text: '2', width: 'auto', fontSize: 5},
                {text: 'of carryover N', width: 'auto', fontSize: 7, margin: [ 2, 0, 0, 0 ]},
              ], 
                  bold: false, 
                  fillColor: 'orange', 
                  border: [false, false, false, false] 
              }]
            ]
          }
        } else {
          var carryoverBanner = {body:[[]]}
        }

    		pdfMake.fonts = {
    		  proxima: {
    				normal: 'proxima-nova-regular.ttf',
    				bold: 'proxima-nova-bold.ttf',
    				italics: 'proxima-nova-italic.ttf',
    				bolditalics: 'proxima-nova-thin.ttf'
    		  }
    		};

        var canvas = document.getElementById('pdf-chart');
        var chart = canvas.toDataURL();

        var summary = []

        for (var i = 0; i < summaryItems.length; i++) {
          var tmp = []
          var item = $(summaryItems[i])
          tmp.push( {text: item.children('.summary-product-title').text(), width: 'auto', fontSize: 10, style: 'bold'} )
          tmp.push( {text: item.children('.summary-part-code').text(), width: 'auto', fontSize: 8} )
          tmp.push( {text: item.children('.summary-qty-cost').text(), width: 'auto', fontSize: 8} )
          tmp.push( {canvas: [{ type: 'line', x1: 0, y1: 5, x2: 492, y2: 5, lineWidth: 0.5, color: '#dddddd'}] } )
          tmp.push( {text: '', width: 'auto', margin: [ 0, 0, 0, 5 ]} )
          summary.push(tmp)
        };

        //return console.log(summary);;

        var docDefinition = {
          // default: 40
    			pageMargins: { "top": 40, "bottom": 110, "left": 60, "right": 60},
    			// width in points: 612
          // margin [L,T,R,B]
    			pageSize: "LETTER",
    			defaultStyle: { font: 'proxima' },
    			styles: {
            normal: {
    				      normal: true
    			  },
            bold: {
    				      bold: true
    			  },
    			  italics: {
    				      italics: true
    			  },
    			  thin: {
    				      bold: true,
    				      italics: true
            },
            tableHeader: {
                  bold: true,
                  fontSize: 6,
            }
    			},
          content: [
            // HEADER
    				{ columns: [
              { width: 'auto',
                stack: [
                  // LOGO
                  { image: logo, width: 75, alignment: 'left', margin: [ 0, 0, 0, 15 ] },
                  { text: currentUser.firstName + ' ' + currentUser.lastName + '\n', style: 'bold', fontSize: 11},
								  { text: currentUser.email + '\n\n', fontSize: 10, margin: [ 0, 2, 0, 5 ] },
                  // TITLE
                  { text: title, style: 'normal', fontSize: 21, margin: [ 0, 0, 0, 5 ] }
                ]
              },
              // SPACER
              { width: '*',
                text: ''
              },
              // SCENARIO DETAILS
              { width: 'auto',
                stack: [
                  { text: [
                      { text: 'Turf Type: ', fontSize: 9, style: 'bold' },
                      { text: turfType.charAt(0).toUpperCase() + turfType.substr(1) + '\n', fontSize: 9 }
                    ],
                    margin: [ 0, 0, 0, 4 ],
                  },
                  { columns: [
                      { text: [
                          { text: 'Target N: ', fontSize: 9, style: 'bold' },
                          { text: targetN, fontSize: 9 },
                        ], width: 'auto', margin: [ 0, 0, 4, 0 ],
                      },
                      {text: targetUnits, fontSize: 9, width: 'auto'},
                      {text: '2', width: 'auto', fontSize: 6},
                      {text: ')', width: 'auto', fontSize: 9,}
                    ], margin: [ 0, 0, 0, 4 ]
                  },
                  { text: [
                      { text: 'Coverage: ', fontSize: 9, style: 'bold' },
                      { text: coverage + '\n', fontSize: 9 }
                    ],
                    margin: [ 0, 0, 0, 4 ],
                  },
                  { text: [
                      { text: 'Zone: ', fontSize: 9, style: 'bold' },
                      { text: zone + '\n', fontSize: 9 }
                    ],
                    margin: [ 0, 0, 0, 4 ],
                  }
								]},

    				]},

            // LEGEND
            { columns: [
              {
                width: 'auto',
                columns: [
                  { canvas: [ {	type: 'rect', x: 0, y: 0, w: 8, h: 8, r: 0, color: '#ffa500', } ]},
                  { text: config.data.datasets[0].label, fontSize: 8, width: 'auto', margin: [ 5, 0, 5, 0 ]}
                ]
              },
              {
                width: 'auto',
                columns: [
                  { canvas: [ {	type: 'rect', x: 0, y: 0, w: 8, h: 8, r: 0, color: '#007a33', } ]},
                  { text: config.data.datasets[1].label, fontSize: 8, width: 'auto', margin: [ 5, 0, 5, 0 ]}
                ]
              },
              {
                width: 'auto',
                columns: [
                  { canvas: [ {	type: 'rect', x: 0, y: 0, w: 8, h: 8, r: 0, color: '#00a9ce', } ]},
                  { text: config.data.datasets[2].label, fontSize: 8, width: 'auto', margin: [ 5, 0, 5, 0 ]}
                ]
              },
              {
                width: 'auto',
                columns: [
                  { canvas: [ {	type: 'rect', x: 0, y: 0, w: 8, h: 8, r: 0, color: '#e6e7e8', } ]},
                  { text: config.data.datasets[3].label, fontSize: 8, width: 'auto', margin: [ 5, 0, 5, 0 ]}
                ]
              },
              {
                width: 'auto',
                columns: [
                  { canvas: [ {	type: 'rect', x: 0, y: 4, w: 12, h: 0.5, r: 0, color: '#000000', } ]},
                  { text: config.data.datasets[4].label, fontSize: 8, width: 'auto', margin: [ 5, 0, 5, 0 ]}
                ]
              }
            ],
              margin: [ 0, 0, 0, 10 ]
            },
            // CARRYOVER BANNER
            {table: carryoverBanner},
            // CHART
            { image: chart, width: 492, margin: [ 0, 10, 0, 10 ] },
            // PREHEADER
            // { stack: preHeader },
            // TABLE
            { table: {
      				widths: appColumns,
      				headerRows: 1,
      				body: parseAppTable() },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
					                   return (rowIndex % 2 === 0) ? null : '#efefef';
				                   },
                vLineWidth: function(){
                              return 0
                            },
                hLineWidth: function(i,node){
                              return ( i==0 || i === node.table.body.length ? 0 : 0.3 )
                            },
                hLineColor: function (i, node) {
            					        return '#cccccc';
            				        },
                paddingLeft: function(i, node) { return 8; },
        				paddingRight: function(i, node) { return 8; },
        				paddingTop: function(i, node) { return 4; },
        				paddingBottom: function(i, node) { return 4; },
               },
              fontSize: 7,
              margin: [0,5,0,20]
            },
            // NUTRIENTS HEADER
            { columns: [
  						{text: 'Seasonal Nutrients Delivered (' + targetUnits, width: 'auto', fontSize: 7},
  						{text: '2', width: 'auto', fontSize: 5},
              {text: ')', width: 'auto', fontSize: 7},
  					]},
            // NUTRIENTS
            { table: {
      				widths: [33,33,33,33,33,33,33,33,33,33],
      				headerRows: 1,
      				body: parseNutrientTable()
            },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
					                   return (rowIndex % 2 === 0) ? null : '#efefef';
				                   },
                vLineWidth: function(){
                              return 0
                            },
                hLineWidth: function(i,node){
                              return ( i==0 || i === node.table.body.length ? 0 : 0.3 )
                            },
                hLineColor: function (i, node) {
            					        return '#cccccc';
            				        },
                paddingLeft: function(i, node) { return 8; },
        				paddingRight: function(i, node) { return 8; },
        				paddingTop: function(i, node) { return 4; },
        				paddingBottom: function(i, node) { return 4; },
               },
              fontSize: 9,
              margin: [0,5,0,5]
            },
            // Summary
            {text: 'Summary:', width: 'auto', fontSize: 7, margin: [0,15,0,5] },
            {stack: summary},
            // NOTES
            {text: 'Notes:', width: 'auto', fontSize: 7, margin: [0,15,0,5] },
            {text: notes, width: 'auto', fontSize: 8}
          ],
          footer: {
              stack: [
                { image: andelogo, width: 100, alignment: 'center', margin: [ 0, 0, 0, 5 ] },
                { text: '© ' + year + ' The Andersons, Inc.', fontSize: 7, alignment: 'center', margin: [ 0, 0, 0, 0 ] },
                { text: 'TurfNutritionTool.com | AndersonsPro.com', fontSize: 7, alignment: 'center', margin: [ 0, 0, 0, 5 ] },
                { text: 'This tool is designed to provide a model for nutrient release over time. Factors like soil health and moisture are not taken into consideration. The Andersons is not responsible for improper product combinations, timing, rates, or application strategies. Always read and follow label directions.', fontSize: 7, alignment: 'center',margin: [ 80, 0, 80, 20 ] },
              ]
          },
        };

        if ( mode == 'view') {
          pdfMake.createPdf(docDefinition).open();
        }

        if ( mode == 'print') {
          pdfMake.createPdf(docDefinition).print();
        }

        if ( mode == 'save') {
          title = 'TNT-' + title.replace(' ', '-');

          pdfMake.createPdf(docDefinition).getBase64(function(encodedString) {

            var data = {
              'string' : encodedString,
              'title' : title
            }

            var tokenName = window.csrfTokenName;
	          data[ tokenName ] = window.csrfTokenValue;

            $.ajax({
                url: '/actions/tnt/scenarios/save-pdf',
                type: 'POST',
                data: data
             })
            .done(function(data) {

              var btnDownload = document.createElement('a');
              btnDownload.href = '/assets/pdf/'+title+'.pdf';
              btnDownload.target = '_blank';
              document.body.appendChild(btnDownload)
              btnDownload.click();
              btnDownload.remove();

            })
            .fail(function(data) {
              console.log(data);
              alert("error");
            });

          });

        }

      })
    });
  });   

  //// HACK: SELECT 2 DROPDOWN IN A BS MODAL //////////////////////////

  // $.fn.modal.Constructor.prototype.enforceFocus = function() {};


}
